import { createContext, useContext } from 'react';
import { CurrentUser } from '../types/auth';

export interface AuthContextValue {
  user: CurrentUser | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  /** Resolves with the freshly-fetched profile — used by the login page to
   * validate a post-login redirect against the just-logged-in user (see
   * utils/routeAuthorization.ts), since this context's own hasPermission
   * is a stale closure until the next render. */
  login: (email: string, password: string) => Promise<CurrentUser>;
  logout: () => Promise<void>;
  refreshProfile: () => Promise<CurrentUser>;
  hasPermission: (module: string, action: string) => boolean;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
  return ctx;
};
